var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "templates" },
    [
      _c(
        "md-field",
        { staticClass: "md-field-margin" },
        [
          _c("label", [_vm._v("Template Name:")]),
          _vm._v(" "),
          _c("md-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|max:60",
                expression: "'required|max:60'"
              }
            ],
            attrs: { name: "name" },
            on: { input: _vm.sanitizeName },
            model: {
              value: _vm.template.name,
              callback: function($$v) {
                _vm.$set(_vm.template, "name", $$v)
              },
              expression: "template.name"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("p", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.errors.has("name"),
            expression: "errors.has('name')"
          }
        ],
        staticClass: "error",
        domProps: { textContent: _vm._s(_vm.errors.first("name")) }
      }),
      _vm._v(" "),
      _c(
        "md-field",
        { staticClass: "md-field-margin" },
        [
          _c("label", [_vm._v("Description:")]),
          _vm._v(" "),
          _c("md-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|max:100",
                expression: "'required|max:100'"
              }
            ],
            attrs: { name: "description" },
            on: { input: _vm.sanitizeDescription },
            model: {
              value: _vm.template.description,
              callback: function($$v) {
                _vm.$set(_vm.template, "description", $$v)
              },
              expression: "template.description"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("p", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.errors.has("description"),
            expression: "errors.has('description')"
          }
        ],
        staticClass: "error",
        domProps: { textContent: _vm._s(_vm.errors.first("description")) }
      }),
      _vm._v(" "),
      _c(
        "md-field",
        { staticClass: "md-field-margin" },
        [
          _c("label", [_vm._v("Reference Id:")]),
          _vm._v(" "),
          _c("md-input", {
            attrs: { disabled: "" },
            model: {
              value: _vm.template.ref_id,
              callback: function($$v) {
                _vm.$set(_vm.template, "ref_id", $$v)
              },
              expression: "template.ref_id"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-field",
        { staticClass: "md-field-margin" },
        [
          _c("label", [_vm._v("Body:")]),
          _vm._v(" "),
          _c("md-textarea", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            attrs: { name: "body" },
            on: { input: _vm.sanitizeBody },
            model: {
              value: _vm.template.body,
              callback: function($$v) {
                _vm.$set(_vm.template, "body", $$v)
              },
              expression: "template.body"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("p", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.errors.has("body"),
            expression: "errors.has('body')"
          }
        ],
        staticClass: "error",
        domProps: { textContent: _vm._s(_vm.errors.first("body")) }
      }),
      _vm._v(" "),
      _c(
        "md-field",
        { staticClass: "md-field-margin" },
        [
          _c("label", [_vm._v("SMS Category:")]),
          _vm._v(" "),
          _c(
            "md-select",
            {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              attrs: {
                name: "category",
                placeholder: "SMS category",
                id: "category"
              },
              model: {
                value: _vm.template.category,
                callback: function($$v) {
                  _vm.$set(_vm.template, "category", $$v)
                },
                expression: "template.category"
              }
            },
            [
              _c("md-option", { attrs: { value: "None" } }, [
                _vm._v("None (no category)")
              ]),
              _vm._v(" "),
              _c("md-option", { attrs: { value: "noFollowUp" } }, [
                _vm._v("No Follow Up")
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("p", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.errors.has("category"),
            expression: "errors.has('category')"
          }
        ],
        staticClass: "error",
        domProps: { textContent: _vm._s(_vm.errors.first("category")) }
      }),
      _vm._v(" "),
      _c(
        "md-field",
        { staticClass: "md-field-margin" },
        [
          _c(
            "md-button",
            {
              staticClass: "md-raised md-round md-accent",
              on: { click: _vm.save }
            },
            [_vm._v(_vm._s(_vm.saveText))]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "md-raised md-round md-accent m-left-20",
              on: {
                click: function($event) {
                  return _vm.deleteTemplate()
                }
              }
            },
            [_vm._v("Delete")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fba1173", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fba1173","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SmsTemplate.vue
// module id = null
// module chunks = 